import { Button, Form, Input, message, Modal, Select, Tag } from 'antd';
import InputMask from 'react-input-mask';
import { Option } from 'antd/lib/mentions';
import React, { useEffect, useState } from 'react';
import { negativeFeedback } from '../../../utils/feedback';
import api from '../../../services/api';

interface IProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  seller: any;
  getSellers: () => void;
}

const UpdateSeller: React.FC<IProps> = ({
  visible,
  setVisible,
  seller,
  getSellers,
}) => {
  const [states, setStates] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [sellerstates, setSellerStates] = useState<Array<any>>([]);

  useEffect(() => {
    if (seller && seller.states) {
      setSellerStates(seller.states);
    }
  }, [seller]);

  useEffect(() => {
    getStates();
  }, []);

  const getStates = async () => {
    try {
      const { data } = await api.get('/states');
      setStates(data.states);
    } catch (err) {
      message.error(negativeFeedback);
    }
  };

  const handleSelectState = (id: any) => {
    const exist = sellerstates.find(item => Number(item.id) === Number(id));
    if (exist) {
      return;
    }
    const find = states.find(item => Number(item.id) === Number(id));
    setSellerStates([...sellerstates, { state: find.name, id: find.id }]);
  };

  const handleRemoveState = (id: any) => {
    const filtered = sellerstates.filter(
      item => Number(item.id) !== Number(id),
    );
    setSellerStates(filtered);
  };

  const handleVisible = () => {
    setVisible(false);
  };

  const handleSubmit = async (items: any) => {
    setLoading(true);
    try {
      const { name, email, phone } = items;
      await api.put(`/seller`, {
        id: seller.id,
        name,
        email,
        phone,
      });

      const ids: any[] = [];
      sellerstates.map(item => ids.push(item.id));

      await api.post(`/seller/states`, {
        id: seller.id,
        states: ids,
      });

      setVisible(false);
      setLoading(false);
      getSellers();
    } catch (err) {
      setLoading(false);
      message.error(negativeFeedback);
    }
  };

  return (
    <Modal
      title="Editar Parceiro"
      onCancel={handleVisible}
      footer={null}
      visible={visible}
    >
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Nome do Vendedor"
          name="name"
          rules={[
            {
              required: true,
              message: 'Por favor, informe o nome do vendedor!',
            },
          ]}
          initialValue={seller?.name}
        >
          <Input
            placeholder="Informe o nome do vendedor"
            value={seller?.name}
          />
        </Form.Item>
        <Form.Item
          label="Email do Vendedor"
          name="email"
          rules={[
            {
              required: true,
              message: 'Por favor, informe o email do vendedor!',
            },
          ]}
          initialValue={seller?.email}
        >
          <Input
            type="email"
            placeholder="Informe o email do vendedor"
            value={seller?.email}
          />
        </Form.Item>
        <Form.Item
          label="Whatsapp do Vendedor"
          name="phone"
          rules={[
            {
              required: true,
              message: 'Por favor, informe o whatsapp do vendedor!',
            },
          ]}
          initialValue={seller?.phone}
        >
          <InputMask
            mask="+55 99 99999-9999"
            type="tel"
            placeholder="Informe o whatsapp do vendedor"
            className="input-mask"
            value={seller?.phone}
          />
        </Form.Item>
        <Form.Item
          label="Estados onde Atende"
          name="states"
          required
          rules={[
            () => ({
              validator() {
                if (sellerstates?.length === 0) {
                  return Promise.reject(
                    new Error(
                      'Por favor, adicione ao menos um estado de atendimento!',
                    ),
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Select onChange={handleSelectState}>
            {states.map(item => (
              <Option key={item.id}>{item.name}</Option>
            ))}
          </Select>
          <br />
          <br />
          <div>
            {sellerstates.map(item => (
              <Tag
                closable
                color="blue"
                onClose={() => {
                  handleRemoveState(item.id);
                }}
                key={item.id}
              >
                {item.state}
              </Tag>
            ))}
          </div>
        </Form.Item>
        <Form.Item>
          <Button loading={loading} type="primary" block htmlType="submit">
            Atualizar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateSeller;
